"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9936 3C7.0228 3 3 6.7257 3 11.3093c0 3.3929 1.422 5.0061 3.3694 6.4784h.0128v3.9818c0 .1281.1025.2305.2306.2305.0513 0 .1025-.0128.141-.0512l3.4078-2.5351.0768.0257c.5765.1024 1.1787.1664 1.768.1664 4.9708 0 8.9936-3.7257 8.9936-8.3093C21 6.7129 16.9516 3 11.9936 3zm5.0733 7.2961c.3331.3457.4997.8066.4997 1.4084v2.8423h-1.1915v-2.6887c0-.6145-.3587-.9474-.9224-.9474-.6149 0-1.0249.3841-1.0249 1.1523v2.4966h-1.1915V7.9531h1.1915v2.471c.2818-.4353.743-.653 1.3836-.653.474 0 .9224.1793 1.2555.525zm-8.084 3.1095c.884 0 1.6271-.525 1.8577-1.3316l1.2939-.0128c-.3203 1.5748-1.5374 2.5991-3.1644 2.5991-1.8833 0-3.3822-1.4084-3.3822-3.3673S7.0869 7.9258 8.97 7.9258c1.6399 0 2.8697 1.0499 3.1772 2.6374h-1.2939c-.1922-.8706-.9737-1.4083-1.8705-1.4083-1.2683 0-2.1139.909-2.1139 2.1381v.0512c.0128 1.1523.9609 2.0742 2.114 2.0614z"
  })];
};

exports.default = _default;